// Lightweight fetch wrapper. Same-origin so cookies are sent automatically.
async function request(method, path, { json, formData, headers = {} } = {}) {
  const opts = { method, credentials: 'include', headers: { ...headers } };
  if (json !== undefined) {
    opts.headers['Content-Type'] = 'application/json';
    opts.body = JSON.stringify(json);
  } else if (formData) {
    opts.body = formData;
  }
  const res = await fetch(path, opts);
  if (res.status === 204) return null;
  const ct = res.headers.get('content-type') || '';
  const body = ct.includes('application/json') ? await res.json() : await res.text();
  if (!res.ok) {
    const err = new Error((body && body.error) || res.statusText || 'Request failed');
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

/**
 * Télécharge un fichier (PDF, XLSX, ZIP…) depuis une route authentifiée.
 *
 * Fait un fetch normal (donc les cookies de session partent), récupère le blob,
 * crée un Object URL temporaire, déclenche le téléchargement, et nettoie.
 * Si le serveur renvoie une erreur JSON (501, 504, etc.), on la fait remonter
 * proprement pour que l'UI puisse afficher un toast d'erreur clair.
 *
 * Le nom du fichier est extrait de l'entête Content-Disposition côté serveur,
 * sinon on prend le fallbackName fourni.
 */
async function downloadFile(path, fallbackName = 'download.bin') {
  const res = await fetch(path, { credentials: 'include' });
  const ct = res.headers.get('content-type') || '';
  if (!res.ok) {
    // Le serveur a probablement renvoyé une erreur JSON {error, detail?}
    let msg = res.statusText || 'Téléchargement impossible';
    if (ct.includes('application/json')) {
      try {
        const body = await res.json();
        msg = body.error || msg;
      } catch {}
    }
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }

  // Récupère le nom de fichier depuis Content-Disposition si présent
  let filename = fallbackName;
  const disp = res.headers.get('content-disposition') || '';
  const m = disp.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  if (m) filename = decodeURIComponent(m[1]);

  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }, 200);
}

export const api = {
  get: (p) => request('GET', p),
  post: (p, json) => request('POST', p, { json }),
  patch: (p, json) => request('PATCH', p, { json }),
  postForm: (p, formData) => request('POST', p, { formData }),
  del: (p) => request('DELETE', p),
  download: downloadFile,
};
